import { getUserInfo } from '../components/Accounts/API'

export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'

export const logOut = () => ({ type: LOG_OUT })
const userInfoLoaded = userInfo => ({ type: LOG_IN, userInfo })

export const loadUserInfo = () => {
    return async dispatch => {
        let userInfo
        try {
            userInfo = await getUserInfo()
        } catch (error) {
            if (error.response?.status === 401) {
                dispatch(logOut())
            }
            return
        }
        dispatch(userInfoLoaded(userInfo))
    }
}
